import React from 'react';
import { Dimmer, Loader } from 'semantic-ui-react';

export default function CustomLoading({ active }) {
  return <Dimmer inverted active={active}>
    <Loader inverted>กำลังโหลด...</Loader>
  </Dimmer>
}